<template>
	<jna-page></jna-page>
</template>

<script>
import JnaPage from './pages/Jna.vue'

export default {
	name: 'App',
	components: {
		JnaPage
	},

}

</script>

